import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ONBOARDING_MAX_STEP } from 'features/onboarding/constants';
import { selectors as profileSelectors } from 'lib/entities/profile';

function useOnBoarding() {
  const [onboardingProgress, setOnboardingProgress] =
    useState<number>(Infinity);

  const { data: dataProfile } = useSelector(profileSelectors);
  const { onboarding: progress, onboarding_done: statusOnboarding } =
    dataProfile;

  useEffect(() => {
    // redirect only if data profile is available
    if (
      dataProfile.id &&
      statusOnboarding == 0 &&
      progress <= ONBOARDING_MAX_STEP
    ) {
      setOnboardingProgress(progress);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progress, statusOnboarding, dataProfile]);

  return { onboardingProgress };
}

export default useOnBoarding;
